import { render, staticRenderFns } from "./SupportTicketSystemMessageBubble.vue?vue&type=template&id=7bbd22c0&scoped=true&"
import script from "./SupportTicketSystemMessageBubble.vue?vue&type=script&lang=ts&"
export * from "./SupportTicketSystemMessageBubble.vue?vue&type=script&lang=ts&"
import style0 from "./SupportTicketSystemMessageBubble.vue?vue&type=style&index=0&id=7bbd22c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbd22c0",
  null
  
)

export default component.exports